import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Link from '@atlaskit/link';

import { FOLDER_VIEW } from '@confluence/named-routes/entry-points/routes.ts';

const i18n = defineMessages({
	parentAccessWarningMessage: {
		id: 'share-and-restrict-dialog.principal-details-warning.principal-details-warning.no-ancestor-permission',
		defaultMessage: 'Needs access to a <parentLink>parent</parentLink> first.',
		description:
			'The warning message in the share and restrict dialog appears when the user lacks permission for one of the ancestor pages.',
	},
});

export const ParentAccessWarning: FC<{
	parentLink: {
		webui: string | null | undefined;
		base: string | null | undefined;
	} | null;
}> = ({ parentLink }) => {
	const getStyledButton = (chunks: React.ReactNode[]) => {
		const { base, webui } = parentLink || {};

		if (!base || !webui) {
			return chunks;
		}
		let parentUrl = `${base}${webui}`;

		if (Boolean(FOLDER_VIEW.match(parentUrl))) {
			parentUrl += '?referrer=share-and-restrict-dialog';
		}

		return (
			<Link href={parentUrl} appearance="default" target="_blank">
				{chunks}
			</Link>
		);
	};

	return (
		<FormattedMessage
			{...i18n.parentAccessWarningMessage}
			values={{
				parentLink: (chunks: React.ReactNode[]) => getStyledButton(chunks),
			}}
		/>
	);
};
